<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue';

// Components
import TheNavigation from '@/components/shell/TheNavigation.vue';

// Ensure scroll position is reset and body classes are cleaned up on mobile when navigating to settings
onMounted(() => {
  // Remove any body classes that might interfere with scrolling
  document.body.classList.remove('overflow-hidden');

  // Small delay to ensure DOM is rendered and body styles are applied
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 0);
});

// Also clean up when component is unmounted
onUnmounted(() => {
  // Ensure we don't leave any overflow restrictions when leaving settings
  document.body.classList.remove('overflow-hidden');
});
</script>

<template>
  <div class="lg:grid lg:grid-cols-12 lg:gap-x-5">
    <TheNavigation />

    <div
      class="flex max-w-3xl flex-col space-y-6 px-4 pb-10 pt-6 sm:px-6 lg:col-span-9 lg:pl-0"
    >
      <routerView />
    </div>
  </div>
</template>
